import React, { useId } from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const LegendLineGroup: React.FC<SvgProps> = (props) => {
  const id = useId();

  return (
    <g fill="none" {...(props.group ?? {})}>
      <line
        x1="21"
        y1="1"
        x2="1"
        y2="1"
        stroke={`url(#${id})`}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id={id}
          x1="1.5"
          y1="1"
          x2="22.5"
          y2="-1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C1AA1" />
          <stop offset="1" stopColor="#485BFF" />
        </linearGradient>
      </defs>
    </g>
  );
};

export const LegendLineSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="2"
      viewBox="0 0 22 2"
      {...(props.svg ?? {})}
    >
      <LegendLineGroup {...props} />
    </svg>
  );
};
